var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckAdvertisement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4003_138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3886 23H6.61163C5.54634 23 4.67962 22.1333 4.67962 21.068V4.93177C4.67962 3.86648 5.54634 2.99976 6.61163 2.99976H17.0225C17.1902 2.99976 17.3511 3.06643 17.4696 3.18491L21.1347 6.85038C21.2532 6.96886 21.3199 7.12974 21.3199 7.29751V21.068C21.3202 22.1336 20.4539 23 19.3886 23Z",
    fill: "url(#paint0_linear_4003_138)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1554 10.5807H8.1592C7.8099 10.5807 7.52691 10.2977 7.52691 9.94839C7.52691 9.59909 7.81026 9.3161 8.1592 9.3161H16.1554C16.5047 9.3161 16.7877 9.59945 16.7877 9.94839C16.788 10.2977 16.5047 10.5807 16.1554 10.5807ZM13.0001 13.79H8.1592C7.8099 13.79 7.52691 13.507 7.52691 13.1577C7.52691 12.8084 7.81026 12.5254 8.1592 12.5254H13.0001C13.3494 12.5254 13.6324 12.8087 13.6324 13.1577C13.6324 13.5066 13.3494 13.79 13.0001 13.79ZM11.7156 16.6843H8.1592C7.8099 16.6843 7.52691 16.4014 7.52691 16.0521C7.52691 15.7028 7.81026 15.4198 8.1592 15.4198H11.7156C12.0649 15.4198 12.3479 15.7031 12.3479 16.0521C12.3482 16.401 12.0649 16.6843 11.7156 16.6843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1351 6.85038L17.47 3.18528C17.3515 3.06679 17.1906 3.00012 17.0228 3.00012V3.63241V6.58804C17.0228 6.96597 17.329 7.27215 17.7069 7.27215H21.3199C21.3133 7.1138 21.2478 6.96307 21.1351 6.85038Z",
    fill: "url(#paint1_linear_4003_138)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4003_138",
    x1: -1.25868,
    y1: 0.192611,
    x2: 11.4025,
    y2: 12.8538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBBBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4003_138",
    x1: 17.0227,
    y1: 5.13606,
    x2: 21.3198,
    y2: 5.13606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4003_138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckAdvertisement);
export default __webpack_public_path__ + "static/media/checkAdvertisement.a10036d8e4e6965688d5e0a261fa3359.svg";
export { ForwardRef as ReactComponent };